/* Optional presentation enhancement only. Native anchors, details and commerce work without JS. */
(() => {
  if (window.orbivanaStoryPresentation) return;
  window.orbivanaStoryPresentation = true;
  const observed = new WeakMap();
  function initialize(scope = document) {
    scope.querySelectorAll('[data-orbivana-story]').forEach(story => {
      if (observed.has(story) || !('IntersectionObserver' in window)) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const links = Array.from(document.querySelectorAll('[data-story-link]'));
      const reveal = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          if (!reduceMotion) entry.target.classList.add('orbivana-story-reveal');
          reveal.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
      story.querySelectorAll('article, .orbivana-product-story__visual, [data-story-panel]').forEach(el => reveal.observe(el));
      const panels = Array.from(story.querySelectorAll('[data-story-panel]'));
      const markCurrent = id => {
        links.forEach(link => {
          if (link.hash === '#' + id) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      const onHashChange = () => {
        const id = window.location.hash.slice(1);
        if (panels.some(panel => panel.id === id)) markCurrent(id);
      };
      const navigation = new IntersectionObserver(() => {
        const visible = panels.map(panel => ({ panel, rect: panel.getBoundingClientRect() }))
          .filter(item => item.rect.bottom > 120 && item.rect.top < window.innerHeight * 0.65);
        const target = visible.find(item => item.panel.id === window.location.hash.slice(1))
          || visible.sort((a, b) => Math.abs(a.rect.top - 120) - Math.abs(b.rect.top - 120))[0];
        if (target) markCurrent(target.panel.id);
      }, { rootMargin: '-15% 0px -45% 0px', threshold: 0 });
      panels.forEach(el => navigation.observe(el));
      window.addEventListener('hashchange', onHashChange);
      onHashChange();
      observed.set(story, [reveal, navigation, { disconnect: () => window.removeEventListener('hashchange', onHashChange) }]);
      story.dataset.presentationReady = 'true';
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-orbivana-story]').forEach(story => {
      observed.get(story)?.forEach(observer => observer.disconnect());
      observed.delete(story);
    });
  });
})();
